import { mocks as translationMocks } from './translations';
import { mocks as thankYouMocks } from './thank-you';
import { mocks as projectMocks } from './project';
import { UnhandledRequestStrategy } from 'msw/lib/core/utils/request/onUnhandledRequest';
import { IS_TEST } from '../../../../constants';
import { HttpHandler } from 'msw';

export const handlers = {
  default: [
    translationMocks.engageDefault,
    translationMocks.userTestDefault,
    thankYouMocks.details,
    ...[IS_TEST ? projectMocks.details : undefined],
  ].filter(Boolean) as HttpHandler[],
};

// Note: Wildcards are only supported at the end or the start of the URL
const excludedUrls = [
  'https://fonts.gstatic.com/*',
  '*/b3c0507a25ead307.woff2',
  'https://fonts.googleapis.com/*',
];

export const unhandledRequestHandler: UnhandledRequestStrategy = ({ method, url }, print) => {
  const isExcluded =
    method === 'GET' &&
    excludedUrls.some((excludedUrl) => {
      const wildcardIndex = excludedUrl.indexOf('*');
      const isWildcardAtStart = wildcardIndex === 0 && url.endsWith(excludedUrl.replace('*', ''));
      const isWildcardAtEnd =
        wildcardIndex === excludedUrl.length - 1 && url.startsWith(excludedUrl.replace('*', ''));

      if (isWildcardAtStart || isWildcardAtEnd) {
        return true;
      }

      return excludedUrl === url;
    });

  if (isExcluded) {
    return;
  }
  // we only want to show unhandled errors calls from our api's
  if (url.includes('/api/')) {
    console.error(`[MSW] - Unhandled ${method} request to ${url}.
              This exception has been only logged in the console, however, it's strongly recommended
              to resolve this error as you don't want unmocked data in Storybook stories.
              If you wish to mock an error response, please refer to this guide:
              https://mswjs.io/docs/recipes/mocking-error-responses
          `);
  } else {
    print.warning();
  }
};
